// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import '@/api'
import Vue from 'vue'
import App from './App'
import store from './store'
import router from './router'
import KsVueScrollmagic from 'ks-vue-scrollmagic'

Vue.use(KsVueScrollmagic)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js